import { toast } from 'sonner';

export interface CopyTextOptions {
  /** What was copied, as it starts the toast: 'Command', 'Client ID', 'Geohash dhwu5k'. */
  label: string;
  /** Replaces '<label> copied' when the outcome carries a consequence ('Snippet copied — it contains your client secret'). */
  successMessage?: string;
  /** Replaces the default failure sentence. */
  failureMessage?: string;
  /**
   * The noun inside the failure sentence. Defaults to the label lower-cased,
   * which reads badly for acronyms ('client id') — pass it for those.
   */
  noun?: string;
}

/**
 * The one path to the clipboard. Success toasts '<Label> copied'; failure logs
 * the original and toasts "Couldn't copy the <noun> — select it and copy
 * manually". Resolves whether the copy happened, so callers can flip an icon.
 */
export async function copyText(text: string, options: CopyTextOptions): Promise<boolean> {
  const { label, successMessage, failureMessage, noun } = options;
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMessage ?? `${label} copied`);
    return true;
  } catch (err: unknown) {
    console.error(`Copying the ${label} failed`, err);
    toast.error(failureMessage ?? `Couldn't copy the ${noun ?? label.toLowerCase()} — select it and copy manually`);
    return false;
  }
}
